(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('SubscriptionDbhController', SubscriptionDbhController);

    SubscriptionDbhController.$inject = ['SubscriptionDbh','$window'];

    function SubscriptionDbhController(SubscriptionDbh, $window) {

        var vm = this;

        vm.subscriptionDbhs = [];

        vm.toggleRow = function (subs) {
            subs.selected = !subs.selected;


        };

        vm.isSelected = function (subs) {
            return subs.selected;
        };

        vm.redirectToApp = function (url) {
            $window.open(url, '_blank');
        };

        loadAll();

        function loadAll() {
            SubscriptionDbh.query(function(result) {
                vm.subscriptionDbhs = result;
                vm.searchQuery = null;
                vm.subscriptionDbhs[0].selected=true;
            });
        }
    }
})();
